<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>保函管理</el-breadcrumb-item>
        <el-breadcrumb-item>履约、预付保函</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss"></style>
